import Select from './Select';
import Org from './Org';
import SearchSelect from './SearchSelect';
import Category from './Category';
import CategoryItems from './CategoryItems';
import Tree from './Tree';
import CategoryMul from './CategoryMul';
import DataGridMul from './DataGridMul';
import ReplyGrid from './ReplyGrid';
import ItemTree from './ItemTree';
import OrgSelect from './OrgSelect';
import Radio from './Radio';

export default {
    Select,
    Org,
    OrgSelect,
    SearchSelect,
    Category,
    CategoryItems,
    Tree,
    CategoryMul,
    DataGridMul,
    ReplyGrid,
    ItemTree,
    Radio
}